var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85999 7.70996L0.690002 2.62012C1.48 1.35012 2.9 0.5 4.5 0.5H14.5C16.1 0.5 17.51 1.34011 18.31 2.61011L11.16 7.68994C10.15 8.35994 8.84999 8.35996 7.85999 7.70996ZM18.98 4.6001L12.3 9.34009C11.44 9.91009 10.46 10.1899 9.48999 10.1899C8.52999 10.1899 7.56998 9.9101 6.72998 9.3501L0.0200195 4.6001C0.0100195 4.7301 0 4.87 0 5V11C0 13.48 2.02 15.5 4.5 15.5H14.5C16.98 15.5 19 13.48 19 11V5C19 4.87 18.99 4.7301 18.98 4.6001Z",
    fill: "url(#paint0_linear_257_2246)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_257_2246",
    x1: 15.418,
    y1: -1.26342,
    x2: -1.1617,
    y2: 12.0514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3465BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00338D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.88e53c40ec5a7831e471d9f163c4ea4d.svg";
export { ForwardRef as ReactComponent };